<template>
  <a>
    <div
      style="
        margin: 0 auto 8px;
        border-radius: 12px;
        padding: 20px;
        height: 80px;
        width: 80px;
        border-radius: 50%;
      "
      :style="{ backgroundColor: color }"
    >
      <img
        :src="`https://platform-cdn.sharethis.com/img/${type}.svg?fm=webp&amp;auto=compress&amp;?q=75&amp;w=100`"
        loading="eager"
      />
    </div>

    <span class="icon-name"> {{ type }}</span></a
  >
</template>

<script>
export default {
  name: 'SocialIcon',
  props: ['type', 'color'],
};
</script>

<style scoped>
a {
  -webkit-text-size-adjust: 100%;
  font-family: 'Open Sans', sans-serif;
  font-size: 1rem;
  line-height: 1.5;
  box-sizing: inherit;
  background-color: transparent;
  text-decoration: none;
  text-align: center;
  width: 13%;
  padding: 28px 36px;
  height: 100%;
  color: #3d3d3d;
  text-transform: capitalize;
}

div {
  -webkit-text-size-adjust: 100%;
  font-family: 'Open Sans', sans-serif;
  font-size: 1rem;
  line-height: 1.5;
  text-align: center;
  color: #3d3d3d;
  box-sizing: inherit;
  margin: 0 auto 8px;
  border-radius: 12px;
  padding: 20px;
  height: 80px;
  width: 80px;
  background-color: #4267b2;
}

img {
  -webkit-text-size-adjust: 100%;
  font-family: 'Open Sans', sans-serif;
  font-size: 1rem;
  line-height: 1.5;
  text-align: center;
  color: #3d3d3d;
  box-sizing: inherit;
  border-style: none;
  height: auto;
  max-width: 100%;
  width: 100%;
}
.icon-name {
  text-align: center;
  width: 100%;
}
</style>
